@if (isLoaded){
@if (activeEvents.length > 0 ){

<div class="row section__header">
    <div class="col-12">
        <h1 class="text-center font-weight-bold">SELECT YOUR EVENT</h1>
    </div>
</div>

@for (event of activeEvents; track event.eventID){
    <a (click)="selectEvent(event);" class="select-event__button w-100" mat-stroked-button>
        <div class="row w-100">
            <div class="col-auto d-flex align-items-center justify-content-center">
                <mat-icon>event</mat-icon>
            </div>
            <div class="col d-flex align-items-start flex-column">
                <h3 class="font-weight-bold mb-0 text-start">{{event.eventName}}</h3>
                <p class="mb-2 text-muted">{{event.startDate | date:'dd MMM yyyy'}} - {{event.endDate | date:'dd MMM yyyy'}}</p>
                <p class="mb-0 font-weight-light text-muted">{{event.city}} - {{event.country}}</p>
            </div>
        </div>
    </a>
}

}
@else{
   <div class="row section__header">
    <div class="col-12 text-center">
        <span class="material-symbols-outlined hand-icon mb-3">event</span>
        <h1 class="text-center font-weight-bold">SORRY THERE ARE NO EVENTS TODAY</h1>
        <p class="text-center font-weight-bold">Please check back later</p>
    </div>
</div> 
}



}